AppTabs.createTab( {
name: 'job-statuses',
icon: 'list-alt',
text: 'Job Statuses',
create: function(init) {
	'use strict'

	init.setDataTableArgs( {

		tableId: 		'#data-table-job-statuses',

		readTableName: 	'tblJobStatuses',
		editTableName: 	'tblJobStatuses',
		primaryKey: 	'JobStatusID',

		canSort:			false,
		paging:				false,

		actionData:			'datatable',
		actionAutofill: 	'datatable_autofill',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'JobStatusOptions' );
		},

		fields: [
			{
				label: 		'Status',
				columnName: 'JobStatus',
				isEditable: true,
				order: 		'asc',
			},
			{
				label: 		'Description',
				columnName: 'JobStatusDescription',
				isEditable: true,
			}
		],

	} );
}

} );
